export const AI_AGREEMENT_URL = 'https://biz.moneyforward.com/ai-agreement/';
